import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { DATE_FORMATS } from 'common/constants/SharedConstants';
import { getFormattedFromUnixWithTimeZone } from 'common/utilities/dayJsUtils';
import { getDisplayOrderId } from 'common/utilities/orderDetailsUtils';
import { updateOrderTrackingDetailsInLocalStorage } from 'common/utilities/orderProcessingSummaryUtils';
import {
  getDeliveryOrderStatusMessageString,
  getOrderStatusValue,
  isDeliveryOrderDelivered,
} from 'common/utilities/orderStatusUtils';
import {
  getTime,
  isCateringDisposition,
  isDeliveryDisposition,
  isDeliveryOrPickupDisposition,
  isPickupDisposition,
  safeUpperCase,
} from 'common/utilities/utils';

export const getActiveOrderHistoryTitle = params => {
  const { postActiveOrderDetail } = params;

  let title = '';

  if (isCateringDisposition(postActiveOrderDetail?.service)) {
    title = safeUpperCase(translateWithI18Next(postActiveOrderDetail?.service));
  } else if (postActiveOrderDetail?.requestedDateTime?.isForNow === false) {
    title = safeUpperCase(translateWithI18Next(TRANSLATE_MAPPING_KEY?.SCHEDULED));
  } else if (isDeliveryOrPickupDisposition(postActiveOrderDetail?.service)) {
    title = safeUpperCase(translateWithI18Next(postActiveOrderDetail?.service));
  }
  return `${title} ${safeUpperCase(translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_HASH))}${getDisplayOrderId(
    postActiveOrderDetail,
  )}`;
};

export const getActiveOrderHistoryInfo = params => {
  const { postActiveOrderDetail } = params;

  if (postActiveOrderDetail?.requestedDateTime?.isForNow === false) {
    return translateWithI18Next(TRANSLATE_MAPPING_KEY?.YOUR_ORDER_IS_SCHEDULED);
  } else if (isDeliveryDisposition(postActiveOrderDetail?.service)) {
    const orderDetails = {
      service: postActiveOrderDetail?.service,
      status: getOrderStatusValue(postActiveOrderDetail),
    };
    return translateWithI18Next(
      getDeliveryOrderStatusMessageString(orderDetails) || TRANSLATE_MAPPING_KEY?.ORDER_GETTING_READY,
    );
  }
  return '';
};

export const getActiveOrderHistoryButtonLabel = params => {
  const { postActiveOrderDetail } = params;
  const { pickupTrackOrderButtonLabel } = params?.activeTrackerDetails;

  if (isCateringDisposition(postActiveOrderDetail?.service)) {
    return translateWithI18Next(TRANSLATE_MAPPING_KEY?.VIEW_DETAILS);
  } else if (postActiveOrderDetail?.requestedDateTime?.isForNow === false) {
    return translateWithI18Next(TRANSLATE_MAPPING_KEY?.TRACK_ORDER);
  } else if (isDeliveryDisposition(postActiveOrderDetail?.service)) {
    return translateWithI18Next(TRANSLATE_MAPPING_KEY?.TRACK_DELIVERY);
  } else if (isPickupDisposition(postActiveOrderDetail?.service)) {
    return translateWithI18Next(pickupTrackOrderButtonLabel);
  }
  return '';
};

export const geActiveOrderHistoryAdditionalInfoLabel = params => {
  const { postActiveOrderDetail } = params;

  if (isCateringDisposition(postActiveOrderDetail?.service)) {
    return `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.READY_TO_COLLECT)} ${translateWithI18Next(
      TRANSLATE_MAPPING_KEY?.AT,
    )}: ${getFormattedFromUnixWithTimeZone(
      postActiveOrderDetail.fulfillmentDateTime,
      postActiveOrderDetail?.store?.timeZoneIANA,
      DATE_FORMATS?.H_MM_A,
    )}`;
  } else if (postActiveOrderDetail?.requestedDateTime?.isForNow === false) {
    return translateWithI18Next(TRANSLATE_MAPPING_KEY?.SCHEDULED_TIME);
  } else if (isDeliveryDisposition(postActiveOrderDetail?.service)) {
    const orderDetails = {
      service: postActiveOrderDetail?.service,
      status: getOrderStatusValue(postActiveOrderDetail),
    };
    return isDeliveryOrderDelivered(orderDetails)
      ? `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.DELIVERED_AT)}: ${getTime(
          postActiveOrderDetail?.estimatedDeliveryTime || postActiveOrderDetail?.deliveryDetails?.estimatedDeliveryTime,
        )}`
      : `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.ESTIMATED_ARRIVAL)}: ${getTime(
          postActiveOrderDetail?.fulfillmentDateTime,
        )}`;
  } else if (isPickupDisposition(postActiveOrderDetail?.service)) {
    return translateWithI18Next(TRANSLATE_MAPPING_KEY?.READY_TO_COLLECT);
  }
  return '';
};

export const onTrackOrderBtnClickHandler = params => {
  const { postActiveOrderDetail, activeTrackerDetails, redirectTo } = params;
  const { props, postActiveOrderHistoryDetailsList } = activeTrackerDetails;

  postActiveOrderHistoryDetailsList?.length > 0 &&
    updateOrderTrackingDetailsInLocalStorage({
      trackDetails: activeTrackerDetails,
      orderDetails: postActiveOrderDetail,
      redirectTo,
      props,
    });
};
